import { render, staticRenderFns } from "./DeliveryConfigurationsByCityManage.vue?vue&type=template&id=7f133824&"
import script from "./DeliveryConfigurationsByCityManage.vue?vue&type=script&lang=js&"
export * from "./DeliveryConfigurationsByCityManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports